const objectToQueryString = function(obj) {
    return Object.keys(obj).map((key) => {
        let val = obj[key];
        if (obj[key] === undefined || obj[key] === null) { val = ''; }
        return encodeURIComponent(key) + '=' + encodeURIComponent(val);
    }).join('&');
}

const AWS_API_BASE = 'https://t79rrarimi.execute-api.ap-south-2.amazonaws.com/default';
const baseUrl = `${window.location.protocol}//${window.location.host}`;

const genericRequest = async function(options, method) {
    if (!options) return { status: false, json: { error: "No options provided" }, statusCode: 400 };
    
    try {
        let requestUrl = options.url || '';
        var url = new URL(requestUrl);
        if (options.params) {
            const searchParams = new URLSearchParams();
            for (const pKey in options.params) {
                if (Array.isArray(options.params[pKey])) {
                    for (const pVal of options.params[pKey]) {
                        searchParams.append(pKey, pVal);
                    }
                } else {
                    searchParams.append(pKey, options.params[pKey])
                }
            }
            url.search = searchParams.toString();
        }
        
        const response = await fetch(url, {
            method: method,
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'include',
            headers: options.headers,
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: method !== "GET" ? JSON.stringify(options.data || {}) : undefined
        });
        
        const isJson = response.headers.get('content-type')?.includes('application/json');
        const json = isJson ? await response.json() : await response.text()
        return { 
            "statusCode": response.status, 
            "json": json,
            "status": (response.status >= 200 && response.status < 300) ? true : false 
        };
    } catch (error) {
        console.error("API Request Error:", error);
        return { 
            status: false, 
            json: { error: error.message || "Network error" }, 
            statusCode: 0 
        };
    }
}

const apiHelper = {
    "fillHeaders": (options) => { options.headers = options.headers ||
        { "content-type": 'application/json' }; },
    "get": (options) => { apiHelper.fillHeaders(options);
        return genericRequest(options, "GET") },
    "post": (options) => { apiHelper.fillHeaders(options);
        return genericRequest(options, "POST") },
    "put": (options) => { apiHelper.fillHeaders(options);
        return genericRequest(options, "PUT") },
    "patch": (options) => { apiHelper.fillHeaders(options);
        return genericRequest(options, "PATCH") },
    "delete": (options) => { apiHelper.fillHeaders(options);
        return genericRequest(options, "DELETE") }
}

export { objectToQueryString, apiHelper, baseUrl };
